import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 搜索商品库存
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function searchProductStock(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/productStock/searchProductStock',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询会员信息
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function searchShopVipUser(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser/searchShopVipUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 计算赠送积分
 * @param {Object} params 计算参数
 * @returns {Promise} 返回Promise对象
 */
export function computeGiveGold(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/computeGiveGold/compute',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询挂单商品
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryStoreOrderCartUp(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderCartUp/queryStoreOrderCartUp',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存挂单信息
 * @param {Object} data 保存数据
 * @returns {Promise} 返回Promise对象
 */
export function saveStoreOrderUp(data) {
  data.storeOrderUp.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderUp/saveStoreOrderUp',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新挂单状态
 * @param {Object} data 更新数据
 * @returns {Promise} 返回Promise对象
 */
export function updateStoreOrderUp(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderUp/updateStoreOrderUp',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询挂单列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryStoreOrderUp(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderUp/queryStoreOrderUp',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}